export default {
      id: "placeholder-usage",
      viewBox: "0 0 41 41",
      url: "/" + "sprite.svg#placeholder",
      toString: function () {
        return this.url;
      }
    }